import React from "react";
import BarIcon from "../Icons/BarIcon";
import FilterIcon from "../Icons/FilterIcon";
import MerchantIcon from "../Icons/MerchantIcon";
import SearchIcon from "../Icons/SearchIcon";
import "./LowerMiddleDashBoard.css";
export default function LowerMiddleDashBoard() {
  return (
    <div className="LowerMiddleDashBoard">
      <div className="Table-options">
        <p>All</p>
        <p className="active-button">Need Review</p>
        <p>Waiting List</p>
        <p>Listed Merchant</p>
        <p>Rejected Merhant</p>
        <p>Suspended Merhant</p>
        <p>Draft</p>
      </div>
      <div className="header-above-table">
        <p className="header-above-table-heading">List Merchant</p>
        <div className="header-above-table-1">
          <SearchIcon />
          <div className="filter-icon">
            <FilterIcon />
            <p>Filter</p>
          </div>
          <div className="add-merchant-icon">
            <MerchantIcon />
            <p>Add Merchant</p>
          </div>
        </div>
      </div>
      <table className="table-full">
        <tr className="table-header">
          <th>Business name</th>
          <th>Category</th>
          <th>Progress</th>
          <th>Rating</th>
        </tr>
        <tr className="table-row-1">
          <td>Summer Mini Bars</td>
          <td>Food & Beverage</td>

          <td>
            {" "}
            <progress
              className="progress-bar-small"
              id="file"
              value="90"
              max="100"
            ></progress>
            90%
          </td>
          <td>*****</td>
        </tr>
        <tr className="table-row-1">
          <td>Centro comercial Moctez</td>
          <td>Food & Beverage</td>
          <td>
            <progress id="file1" value="40" max="100"></progress>
            40%
          </td>
          <td>*****</td>
        </tr>
        <tr className="table-row-1">
          <td>Ernst Handel</td>
          <td>Food & Beverage</td>
          <td>
            <progress id="file1" value="20" max="100"></progress>20%
          </td>
          <td>*****</td>
        </tr>
      </table>
    </div>
  );
}
